// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__ugV2a","input":"styles_input__VmmyY","btn_submit":"styles_btn_submit__kB04m"};